<template>
  <div class="flex" v-if="$PLATFORM == 'web'">
    <StoryItem
      v-for="(story, index) in stories"
      :key="index"
      :title="story.title"
      :borderColor="story.borderColor"
      :story="story"
      @click="activeStoryIndex = index"
    />

    <StoryViewer
      v-for="(story, index) in stories"
      :key="index"
      :story="story"
      :isActive="activeStoryIndex === index"
      @end="closeStory"
      :is-background="story.onlyBackground"
      @storyActionClick="handeStoryAction"
    />
  </div>
</template>

<script lang="ts">
import StoryItem from "@/components/Stories/StoryItem.vue";
import StoryViewer from "@/components/Stories/StoryViever.vue";
import { IStory } from "@/struct/IStory/IStory";
import * as Sentry from "@sentry/vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    StoryItem,
    StoryViewer,
  },
})
export default class StoryList extends Vue {
  private stories: IStory[] = [
    {
      title: "Бонусы \n за друга",
      previewImage: require("@/assets/img/story/refferal/preview.png"),
      progressColor: "bg-grey",
      slides: [
        {
          image: require("@/assets/img/story/refferal/slide1.png"),
          title: "У нас для вас есть \n выгодное \n предложение!",
          description:
            "Получайте бонусы с нашей новой реферальной программой. Приглашайте друзей и получайте выгоду! \n\n Не упустите шанс начать накапливать бонусы уже сегодня",
        },
        {
          image: require("@/assets/img/story/refferal/slide2.png"),
          title: "Что нужно для \n получения \n бонуса?",
          description:
            "1. Перейдите по кнопке внизу \n\n 2. Скопируйте ссылку и отправляйте друзьям \n\n 3. Ждите свой бонус \n\n Присоединяйтесь и начинайте накапливать бонусы уже сегодня!",
          buttonText: "Получить бонус",
          buttonAction: "redirectToReferral",
          buttonColor: "white",
        },
      ],
    },
    {
      title: "Вывод СБП",
      previewImage: require("@/assets/img/story/sbp/preview.svg"),
      slides: [
        {
          image: require("@/assets/img/story/sbp/slide1.png"),
          title: "Самые низкие комиссии",
          description:
            "Наша новая функция вывода через систему быстрых платежей обеспечивает наименьшие возможные комиссии. \n\n Экономьте больше с каждым переводом!",
        },
        {
          image: require("@/assets/img/story/sbp/slide2.png"),
          title: "Ускоренные переводы",
          description:
            "Благодаря новой системе быстрых платежей, ваши переводы осуществляются мгновенно. \n\n Больше не нужно ждать получения своих средств!",
        },
        {
          image: require("@/assets/img/story/sbp/slide3.png"),
          title: "Простота в  \n добавлении",
          description:
            "Добавление и использование новой системы быстрых платежей в нашем приложении легко и удобно.",
          buttonText: "Подключить СБП",
          buttonAction: "redirectToSbp",
          buttonColor: "primary",
        },
      ],
    },
    {
      title: "Коды в Telegram",
      previewImage: require("@/assets/img/story/t-bot/preview.png"),
      slides: [
        {
          image: require("@/assets/img/story/t-bot/slide1.png"),
          title: "Быстрый вход в через Telegram.",
          description:
            "Получайте код через Telegram, это быстрее чем по звонку.",
          buttonText: "Подключить",
          buttonAction: "redirectToTBot",
          buttonColor: "primary",
        },
        {
          image: require("@/assets/img/story/t-bot/slide2.png"),
          title: "Надежно.",
          description: "Ваши данные защищены безопасным соединением.",
          buttonText: "Подключить",
          buttonAction: "redirectToTBot",
          buttonColor: "primary",
        },
        {
          image: require("@/assets/img/story/t-bot/slide3.png"),
          title: "Просто подключить.",
          description:
            "Чтобы получать коды через Telegram - нажмите кнопку ниже.",
          buttonText: "Подключить",
          buttonAction: "redirectToTBot",
          buttonColor: "primary",
        },
      ],
    },
  ];

  private activeStoryIndex: number | null = null;

  /*************  ✨ Codeium Command ⭐  *************/
  /**
   * Close the active story.
   * Set activeStoryIndex to null, which cause the StoryViewer to hide.
   */
  /******  783e50ba-da79-4cb4-b8b8-2700b433fd26  *******/
  private closeStory() {
    this.activeStoryIndex = null;
  }

  private handeStoryAction(action: string) {
    if (this[action]) {
      // Вызываем функцию из слайда
      this[action]();
    }
  }

  private redirectToSbp() {
    this.closeStory();
    this.$router.push({ path: "/new-card", query: { open: "sbp" } });
  }
  private redirectToReferral() {
    this.closeStory();
    this.$router.push("/referral-page");
    Sentry.captureMessage("Action click in story");
  }
  private redirectToTBot() {
    this.closeStory();
    window.open(process.env.VUE_APP_TELEGRAM_URL, "_blank");
  }
}
</script>
